import { ChangeEvent, MouseEvent, useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { ApiError } from "components";
import {
  ResetCommercialPasswordInput,
  ResetCommercialPasswordInputError,
} from "modules/user_management/commercial_user/user/state/actionType";
import { ValidateRsetPassowrdForm } from "modules/user_management/commercial_user/user/page/manage_commercial_user/components/ValidateForm";
import {
  DcddUserProps,
  RegisteredDcddUserProps,
  stateStatusType,
  UpdatePasswordInput,
} from "../state/actionType";
import ResetDcddPasswordForm from "./components/ResetDcddPasswordForm";
import { updateDcddUserPassword } from "../state/action";

interface OwnProps {
  onClose: () => void;
  dcddData: DcddUserProps;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandleResetDcddPassword: React.FC<Props> = ({
  onClose,
  dcddData,
  onUpdatePassword,
}) => {
   const dcddCreateState = useSelector(
    (state: any) => state.dcddUser.genericDcddUserState
  );
  const [formData, setFormData] = useState<ResetCommercialPasswordInput>({
    user_id: dcddData?.id?.toString(),
    password: "",
    confirm_password: "",
  });
  const [error, setError] = useState<ResetCommercialPasswordInputError>({});
  const [apiError, setApiError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  const handleSubmit = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setSubmitted(true);
    const validationErrors = ValidateRsetPassowrdForm(formData);
    if (Object.keys(validationErrors).length > 0) {
      setError(validationErrors);
      return;
    }
    setIsLoading(true);
    const input: UpdatePasswordInput = {
      password: formData.password,
    };
    onUpdatePassword(dcddData?.id?.toString(), input);
    setIsLoading(false);
  };
  useEffect(() => {
    if (
      submitted &&
      dcddCreateState.status === stateStatusType.SUCCESS &&
      dcddCreateState.error === null
    ) {
      onClose(); // Close the modal
    } else {
      setApiError(dcddCreateState.error);
    }
  }, [
    submitted,
    dcddCreateState.status,
    dcddCreateState.error,
    onClose,
  ]);
  return (
    <>
      <ResetDcddPasswordForm
        header={"Update user password"}
        loading={isLoading}
        formData={formData}
        error={error}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        onClose={onClose}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onUpdatePassword: (
    password: string,
    ResetPasswordInput: UpdatePasswordInput
  ) => dispatch(updateDcddUserPassword(password, ResetPasswordInput)),
});

export default connect(null, mapDispatchToProps)(HandleResetDcddPassword);
